import { localId } from 'src/app/helpers/local-id';

export class InfoCode {
  public readonly id = localId();

  public constructor(
    public materialNumber: string,
    public codeGroup: string,
    public activityCode: string,
    public activityCodeText: string,
    public activityText: string,
    public activityNumber: string,
    public createdBy: string,
    public longText: string,
    public longTextAvailable: boolean,
    public notificationNumber: string,
    public createdOn?: Date
  ) {}
}
